import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List, Row, Select, Space } from "antd";
import Text from "antd/lib/typography/Text";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { bcfViewerStore } from "./BCFViewerStore";

export const BCFViewerComments: React.FC = observer(() => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const handleSort = (v: string) => {
    const [key, direction] = v.split("_");
    bcfViewerStore.sortCommentsBy(key as keyof API_BcfComment, direction as "asc" | "desc");
  };
  const handleSnapshotClick = (id: string) => {
    bcfViewerStore.fetchCommentPreview(id);
  };

  return (
    <Row className="bcf-comment-container">
      <Space className="mb-lg">
        <Space className="bcf-comment-filter">
          <span>{t("Sort by", { ns: I18N_NS.PROJECT })}:</span>
          <Select defaultValue="date_desc" style={{ width: 150 }} onChange={handleSort}>
            <Select.Option value="author_desc">
              {t("Author", { ns: I18N_NS.PROJECT })}
              <FontAwesomeIcon fixedWidth={true} style={{ marginLeft: 8 }} icon={["far", "arrow-down"]} />
            </Select.Option>
            <Select.Option value="author_asc">
              {t("Author", { ns: I18N_NS.PROJECT })}
              <FontAwesomeIcon fixedWidth={true} style={{ marginLeft: 8 }} icon={["far", "arrow-up"]} />
            </Select.Option>
            <Select.Option value="date_desc">
              {t("Date", { ns: I18N_NS.PROJECT })}
              <FontAwesomeIcon fixedWidth={true} style={{ marginLeft: 8 }} icon={["far", "arrow-down"]} />
            </Select.Option>
            <Select.Option value="date_asc">
              {t("Date", { ns: I18N_NS.PROJECT })}
              <FontAwesomeIcon fixedWidth={true} style={{ marginLeft: 8 }} icon={["far", "arrow-up"]} />
            </Select.Option>
          </Select>
        </Space>
        <Space className="bcf-comment-filter mr-10">
          <span>{t("Filter by author", { ns: I18N_NS.PROJECT })}:</span>
          <Select
            defaultValue={t("All", { ns: I18N_NS.PROJECT })}
            style={{ width: 250 }}
            onChange={(v) => bcfViewerStore.filterCommentsBy("author", v)}
          >
            {bcfViewerStore.authorsFilters.map((v, idx) => (
              <Select.Option value={v} key={v + idx}>
                {v}
              </Select.Option>
            ))}
            <Select.Option value={"all"}>{t("All", { ns: I18N_NS.PROJECT })}</Select.Option>
          </Select>
        </Space>
      </Space>
      <div className="fullWidth">
        <List
          itemLayout="vertical"
          dataSource={bcfViewerStore.activeComments}
          renderItem={(comment) => (
            <List.Item key={comment.guid}>
              <List.Item.Meta title={comment.author} description={<span>{comment.date}</span>} />
              <div>
                <Space className="bcf-comment-container">
                  <p>{comment.commentText}</p>
                  {comment.snapshotFilename && (
                    <span className="bcf-comment-snapshot" onClick={() => handleSnapshotClick(comment.guid)}>
                      <Text type="secondary" underline>
                        {comment.snapshotFilename}
                      </Text>
                    </span>
                  )}
                </Space>
              </div>
            </List.Item>
          )}
        />
      </div>
    </Row>
  );
});
